import React, { useState } from "react";
import { Modal, Button, ActionIcon, Text } from "rizzui";
import { PiXLight } from "react-icons/pi";

interface GenericModalProps {
    onConfirm: () => void;
    title: string;
    icon?: React.ReactNode;
    description?: string;
    color: "primary" | "secondary" | "danger" | undefined;
    size?: "sm" | "md" | "lg" | "xl" | undefined;
    buttonType: "text" | "solid" | "flat" | "outline" | undefined;
}

const GenericModal: React.FC<GenericModalProps> = ({
    buttonType,
    icon,
    color,
    size,
    onConfirm,
    title,
    description,
}) => {
    const [modalState, setModalState] = useState(false);

    async function handleConfirm() {
        setModalState(false);
        onConfirm();
    }

    return (
        <>
            <Button
                onClick={() => setModalState(true)}
                variant={buttonType}
                color={color}
                size={size ? size : "md"}
            >
              {icon ? icon : title}
            </Button>
            <Modal isOpen={modalState} onClose={() => setModalState(false)}>
                <div className="m-auto px-7 pt-6 pb-8">
                    <div className="mb-7 flex items-center justify-between">
                        <div className="flex flex-col ">
                            <Text className="text-lg font-semibold h3">
                                {title}
                            </Text>
                            <p className="text-sm text-gray-500">
                                {description}
                            </p>
                        </div>
                        <ActionIcon
                            size="sm"
                            variant="text"
                            onClick={() => setModalState(false)}
                        >
                            <PiXLight
                                className="h-auto w-6"
                                strokeWidth={1.8}
                            />
                        </ActionIcon>
                    </div>
                    <div className="flex justify-end gap-4">
                        <Button
                            variant="outline"
                            color="secondary"
                            onClick={() => setModalState(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="flat"
                            color="primary"
                            onClick={handleConfirm}
                        >
                            Confirm
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default GenericModal;
